import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import { getActiveCrawlerSection } from '@hydra/utils/parseRouteParams';

import IssueCounterRow from '@hydra/routes/crawler/components/IssueCounterRow';

export class HttpStatusCategory extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    params: PropTypes.shape({
      lang: PropTypes.string,
      url: PropTypes.string
    }).isRequired,
    project: PropTypes.shape({
      host: PropTypes.string,
      crawls: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              countNoindexedPages: PropTypes.number,
              countNofollowedPages: PropTypes.number,
              countDisallowedPages: PropTypes.number
            })
          })
        )
      })
    }),
    location: PropTypes.object,
    url: PropTypes.string
  }

  static childContextTypes = {
    location: PropTypes.object
  }

  getChildContext () {
    return {
      location: this.props.location
    };
  }

  getCounters (props) {
    const { lang, url } = props.params;
    const activeSection = getActiveCrawlerSection(props.routes);
    const baseUrl = `/${lang}/crawler/${encodeURIComponent(url)}/http-status`;
    const crawlNode = get(props, 'project.crawls.edges[0].node', {});

    return [
      {
        active: activeSection === '5xx-errors',
        amount: crawlNode.countHttp5xxErrors || 0,
        label: <Translate content='crawler_5xx_errors' />,
        link: `${baseUrl}/5xx-errors`,
        name: '5xx-errors'
      },
      {
        active: activeSection === '4xx-errors',
        amount: crawlNode.countHttp4xxErrors || 0,
        label: <Translate content='crawler_4xx_errors' />,
        link: `${baseUrl}/4xx-errors`,
        name: '4xx-errors'
      },
      {
        active: activeSection === '3xx-redirects',
        amount: crawlNode.countHttp3xxRedirects || 0,
        label: <Translate content='crawler_3xx_redirects' />,
        link: `${baseUrl}/3xx-redirects`,
        name: '3xx-redirects'
      },
      {
        active: activeSection === 'http-within-https',
        amount: crawlNode.countHttpInHttps || 0,
        label: <Translate content='crawler_http_within_https' />,
        link: `${baseUrl}/http-within-https`,
        name: 'http-within-https'
      },
      {
        active: activeSection === 'crawl-errors',
        amount: crawlNode.countCrawlErrors || 0,
        label: <Translate content='crawler_crawl_errors' />,
        link: `${baseUrl}/crawl-errors`,
        name: 'crawl-errors'
      }
    ];
  }

  render () {
    const { children } = this.props;

    return (
      <div className='nr-crawler-http-status-category'>
        <IssueCounterRow counters={this.getCounters(this.props)} />
        {children}
      </div>
    );
  }
}

export default createFragmentContainer(HttpStatusCategory, {
  project: graphql`
    fragment HttpStatusCategory_project on Project {
      host
      crawls (offset: 0, limit: 1) {
        edges {
          cursor,
          node {
            countHttp3xxRedirects,
            countHttp4xxErrors,
            countHttp5xxErrors,
            countHttpInHttps,
            countCrawlErrors
          }
        }
      }
    }
  `
});
